<template>
  <subsection-list
    placeholder="New Category"
    :list="serviceCategories"
    @create="createCategory"
    @delete="deleteCategory"
    @edit="editCategory"/>
</template>

<script>
import SubsectionList from '@/components/Settings/Services/SubsectionList/SubsectionList'
import ServiceCategoriesApi from '@/api/ServiceCategory/api'
import serviceCategoriesList from '@/mixin/serviceCategoriesList'
import _ from 'lodash'

export default {
  name: 'ServiceCategories',
  components: {
    SubsectionList
  },
  mixins: [serviceCategoriesList],
  computed: {
    serviceCategories: {
      get: function () {
        return this.$store.getters.serviceCategories
      },
      set: function (data) {
        this.$store.dispatch('setServiceCategories', data)
      }
    },
    activeCompany: function () {
      return this.$store.getters.activeCompany
    }
  },
  methods: {
    getCategories () {
      this.serviceCategories = this.serviceCategoriesList
    },
    createCategory (category) {
      ServiceCategoriesApi.createCategory(category)
        .then((resp) => {
          this.serviceCategories.unshift(resp.data)
          category.name = ''
        })
        .catch((err) => {
          console.error(err)
        })
    },
    editCategory (item, index) {
      const trueIndex = (_.findIndex(this.serviceCategories, {id: item.id}))
      ServiceCategoriesApi.editCategory(item)
        .then((resp) => {
          this.serviceCategories.splice(trueIndex, 1, resp.data)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    deleteCategory (index, id) {
      const trueIndex = (_.findIndex(this.serviceCategories, {id: id}))
      ServiceCategoriesApi.deleteCategory(id)
        .then((resp) => {
          this.serviceCategories.splice(trueIndex, 1)
        })
        .catch((err) => {
          console.error(err)
        })
    }
  },
  watch: {
    activeCompany: function () {
      this.getCategories()
    }
  },
  beforeMount () {
    if (this.serviceCategories.length === 0 || this.serviceCategories[0].company !== this.activeCompany) {
      this.getCategories()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";

</style>



// WEBPACK FOOTER //
// src/components/Settings/Services/ServiceCategories/ServiceCategories.vue